module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "21",
      "height": "21",
      "viewBox": "0 0 21 21"
    }
  }, [_c('g', {
    attrs: {
      "fill": _vm.active ? _vm.globalColors.titulo : _vm.globalColors.border,
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.121 14.758l-1.145-1.213a.328.328 0 0 0-.439-.038l-4.989 3.823-1.766-.864 1.55-.18a.347.347 0 0 0 .297-.35v-1.52a.345.345 0 0 0-.337-.35h-1.69l-2.843-.303a.326.326 0 0 0-.169.028l-1.939.865H0v.703h3.722c.047 0 .093-.01.135-.028l1.922-.875 2.773.295h1.415v.871l-1.25.162-1.813-.2a.339.339 0 0 0-.358.256.356.356 0 0 0 .179.411l3.746 1.793c.11.052.24.039.337-.035l4.912-3.754.675.731-5.644 5.131h-1.53l-5.387-2.084a.326.326 0 0 0-.119-.024H0v.702h3.658L9.042 20.8a.326.326 0 0 0 .118.021h1.716a.33.33 0 0 0 .223-.088l6.005-5.461a.362.362 0 0 0 .017-.513zM18.407 8.373l-1.725-1.805a.326.326 0 0 0-.21-.102l-3.529-.328h-1.346l.065-.986 1.278-.26 1.784.401a.325.325 0 0 0 .111 0l1.735-.207-.078-.657-1.68.18-1.797-.4a.266.266 0 0 0-.134 0l-1.591.328a.328.328 0 0 0-.265.303l-.104 1.6-.001.02c0 .182.147.329.327.329h1.667l3.379.308 1.738 1.831a.326.326 0 0 0 .235.102h2.314v-.657h-2.173zM17.512 1.334a.313.313 0 0 0-.13-.057L11.59.007a.36.36 0 0 0-.28.06L7.56 2.607l.402.515L11.585.667l5.57 1.22 3.01 2.182.415-.512-3.068-2.223z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.261 2.547a.328.328 0 0 0-.262 0l-1.919.932.288.553 1.79-.867 1.465.581.237-.577-1.599-.622zM8.035 5.373l-.46-.073c-.209-.033-.332-.12-.332-.26s.183-.28.429-.266h.188c.246 0 .43.14.43.266v.076h.522V5.04c0-.476-.418-.84-.952-.84h-.188c-.534 0-.952.364-.952.84.043.437.375.776.785.8l.452.074c.21.033.332.134.332.26s-.183.266-.429.266h-.188c-.246 0-.429-.14-.429-.266v-.076H6.72v.076c0 .462.429.826.952.826h.188c.534 0 .952-.364.96-.812-.037-.442-.37-.789-.785-.815z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.708 6a2.533 2.533 0 0 1-4.804.718 2.516 2.516 0 0 1 1.241-3.341A2.533 2.533 0 0 1 10.5 4.615l.572-.265a3.162 3.162 0 0 0-2.87-1.83A3.156 3.156 0 0 0 5.04 5.67c0 1.74 1.415 3.15 3.161 3.15a3.157 3.157 0 0 0 3.139-2.734L10.708 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.56 4.2h1v1h-1z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-463eb07d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-components/paySvg.vue
// module id = 1106
// module chunks = 34